import React, { useEffect, useState } from "react";
import { GoogleMap, LoadScript, MarkerF } from "@react-google-maps/api";
import "./Map.scss";
import { useTranslation } from "react-i18next";

const Map = () => {
  const { t } = useTranslation();

  // Google Maps container style
  const containerStyle = {
    width: "100%",
    height: "500px", // Ensure height is set to a fixed value
  };

  // Map center coordinates (e.g., for New York City)
  const center = {
    lat: 40.7128,
    lng: -74.006,
  };

  // Example location data (Left Side)
  const locationsRaw = t("locationsSection.locations", { returnObjects: true });
  const locations = Array.isArray(locationsRaw) ? locationsRaw : [];

  // Set the default selected location to the first location
  const [selectedLocation, setSelectedLocation] = useState(null);

  useEffect(() => {
    if (locations.length > 0) {
      setSelectedLocation((current) => current ?? locations[0]);
    }
  }, [locations]);

  if (!selectedLocation) {
    return null;
  }

  return (
    // <div className="map-container" style={{ display: "flex", height: "500px" }}>
    <div className="map-container">
      {/* Left Side: Locations */}
      {/* <div className="info-section" style={{ width: "50%", padding: "10px", backgroundColor: "#f4f4f4", overflowY: "auto" }}> */}
      <div className="info-section">
        <h2>{t("locations")}</h2>
        {locations.map((location, index) => (
          <div
            key={index}
            className={`location-card ${
              selectedLocation.name === location.name ? "active" : ""
            }`}
            // style={{
            //   padding: "10px",
            //   marginBottom: "10px",
            //   cursor: "pointer",
            //   backgroundColor: selectedLocation.name === location.name ? "#d3e5ff" : "#fff",
            //   border: "1px solid #ddd",
            // }}
            onClick={() => {
              setSelectedLocation(location); // Update selected location
            }}
          >
            <h3>{location.name}</h3>
            <p>{location.address}</p>
          </div>
        ))}
      </div>

      {/* Right Side: Map */}
      {/* <div className="map-section" style={{ width: "50%" }}> */}
      <div className="map-section">
        <LoadScript googleMapsApiKey="AIzaSyBlPFTTgfroFJABMD6hp-IO0IJUYPCYsm0">
          <GoogleMap
            mapContainerStyle={containerStyle}
            center={selectedLocation.coordinates} // Center map on the selected location
            zoom={12}
          >
            {/* Add markers for each location */}
            {locations.map((location, index) => (
              <MarkerF
                key={index}
                position={location.coordinates}
                onClick={() => setSelectedLocation(location)} // Update the selected location on marker click
              />
            ))}
            {/* Highlight the selected marker */}
            <MarkerF position={selectedLocation.coordinates} />
          </GoogleMap>
        </LoadScript>
      </div>
    </div>
  );
};

export default Map;
